/**
 * GridNavigationHelper - Utility for managing grid navigation and return URLs
 * Provides reusable methods for grid components to handle edit navigation consistently
 */
import NavigationStateManager from './NavigationStateManager';

class GridNavigationHelper {
  /**
   * Clears any stored return URL when entering a grid page
   * Should be called once in componentDidMount or useEffect
   */
  static clearReturnUrlOnGridEntry() {
    NavigationStateManager.clearReturnUrl();
  }

  /**
   * Sets the current page as return URL and calls legacy setRedirectUrl for compatibility
   * Use this in grid context menu edit handlers
   */
  static handleEditNavigation(setRedirectUrlCallback, location) {
    // Set return URL using NavigationStateManager
    NavigationStateManager.setCurrentPageAsReturnUrl();
    
    // Maintain existing Redux behavior for compatibility
    if (setRedirectUrlCallback && location) {
      setRedirectUrlCallback(location.pathname + location.search);
    }
  }

  /**
   * Higher-order function that wraps a context menu onClick handler
   * to automatically handle return URL setting
   */
  static withReturnUrlHandler(originalHandler, setRedirectUrlCallback, location) {
    return (...args) => {
      // Set return URL first
      GridNavigationHelper.handleEditNavigation(setRedirectUrlCallback, location);
      
      // Call original handler if provided
      if (originalHandler) {
        return originalHandler(...args);
      }
    };
  }

  /**
   * Creates a standardized onClick handler for edit context menu items
   */
  static createEditClickHandler(setRedirectUrlCallback, location) {
    return () => {
      GridNavigationHelper.handleEditNavigation(setRedirectUrlCallback, location);
    };
  }
}

export default GridNavigationHelper;
